import { GetterTree } from 'vuex'
import MonthlyContractState, { IMonthlyContract } from './states'
import { State } from '@/store/store'
import _ from 'lodash'

const getters: GetterTree<MonthlyContractState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  itemLists: (state) => {
    return state.list.result
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
}

export default getters
